module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/utees-bldg-90caa59dcc0f9fd2951cff06e067d353.jpg";